var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-pdf-viewer", {
    attrs: { blob: _vm.blob, images: _vm.images },
    on: {
      "fetch-images": function ($event) {
        _vm.shouldFetchAsImage = true
      },
      "fetch-blob": function ($event) {
        _vm.shouldFetchAsImage = false
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }